<template>
    <NavBar />
    <router-view />
</template>
<script lang="ts">
import { defineComponent, inject } from 'vue';

export default defineComponent({
    setup: () => {
        const user = inject('loggedInUser');
        return { user };
    }
});
</script>
<style lang="scss">

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

body {
  margin: 0px;
}
.vue-base-navbar{
    display: flex;
    justify-content: space-evenly;
    padding: 2rem 1rem;
}

</style>
